//Displays a currency value in the format of the current locale
import {formatCurrency} from "../Internationalization/Formatters";
import {roundHalfUp} from "./PlanUtils";
import moment from "moment/moment";
import {useTranslation} from "react-i18next";

export const displayCurrency = (value, language, decimals = 0) => {
    return formatCurrency(roundHalfUp(value, decimals), language, decimals);
}

//Displays a date in the format MMM D, YYYY
// If the date is invalid, an empty string is returned
export const displayDate = (value) => {
    const ret = moment(value).format('MMM D, YYYY');
    if (ret === 'Invalid date') { return ''; }
    return ret;
}

//Displays a date in the format HH:MMA MMM D, YYYY
// If the date is invalid, an empty string is returned
export const displayDateTime = (value) => {
    const ret = moment(value).format('h:mma MMM D, YYYY');
    if (ret === 'Invalid date') { return ''; }
    return ret;
}


export const displayUnits = (value) => {
    return roundHalfUp(value, 3).toFixed(3);
}

export function sprintf(string, ...args) {

    console.log("sprintf string", string);

    // get slots of % and then any character from a-z or @
    const slots = string.match(/%[a-z@]/g);
    if (!slots) {
        return string;
    }

    let result = string;

    // replace each slot with the corresponding argument
    slots.forEach((slot, index) => {
        const arg = args[index];
            result = result.replace(slot, arg);
    });

    return result;
}